export default "__VITE_ASSET__CEMI3AfX__"